import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.planning')
  .service('PlanningProjectsProcessTrackingAPI', PlanningProjectsProcessTrackingAPI);

function PlanningProjectsProcessTrackingAPI(): BringozApi {
  return {
    base: `/planning/processTracking`,
    infiniteScroll: {
      address: `/planning/processTracking`,
      cmd: 'GET'
    },
    actions: {
      getProcesses: {
        address: 'process/{projectId}',
        cmd: 'GET',
        updateable: false
      },
      getProcess: {
        address: '{id}',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
